<div class="h-100 d-flex flex-column" [ngStyle]="{ 'max-height': !data?.detail ? '75vh' : '75vh' }" style="overflow: auto; position: relative;">
  <!-- HEADER -->
  <div style="position: relative" class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center pt-5 px-5" style="gap: 0.5em">
      <div class="d-flex flex-column mr-3">
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 33px; font-weight: 400; line-height: 1.2">
          {{ data?.detail ? "Detalles del Plan" : (data?.quote ? "Seleccionaste" : "Detalle") }}
        </p>
        <p class="mb-0" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 33px; font-weight: 600; line-height: 1">
          {{ data?.detail ? "Seleccionado" : (data?.quote ? "Estos Productos" : "De Producto") }}
        </p>
      </div>
      <div>
        <img src="../../../assets/icons/itinerary-detail/FLECHA_VOUCHER-01.svg" style="width: 58px; height: 58px; transform: scaleX(-1);" alt="" />
      </div>
    </div>
    <button type="button" class="close btn-closed" style="position: relative !important;" aria-label="Close" (click)="decline()">
      <span aria-hidden="true" style="font-size: 50px; font-weight: 100; color: black">&times;</span>
    </button>
  </div>

  <!-- INSURANCE BODY -->
  <div class="d-flex flex-column py-5 px-5 w-100" style="position: relative; align-items: center;">
    <div class="mb-4 w-100">
      <ng-container *ngIf="loadInsurance">
        <div class="d-flex flex-column w-100" style="gap: 1em">
          <ng-container *ngFor="let item of insurances">
            <div class="d-flex flex-column" style="border: 2px solid #bfbfbf; border-radius: 8px; padding: 0px 0px 60px;">
              <div
                class="row align-items-center"
                [ngStyle]="{
                  'border-bottom': !data?.detail
                    ? '2px solid #bfbfbf'
                    : '3px solid #000000'
                }"
                style="width: 100%; margin: 0;"
              >
                <div
                  class="col-4"
                  [ngStyle]="{
                    'border-right': !data?.detail
                      ? 'none'
                      : '2px solid #bfbfbf'
                  }"
                  style="padding: 25px 0px 30px 25px;"
                >
                  <div class="w-100" style="padding: 0px 35px;">
                    <img *ngIf="quote"  src="{{  item?.provider?.logo }}" alt="" style="height: 130px; width: 200px; object-fit: contain;" />
                    <img *ngIf="!quote"  src="{{ item?.plan?.provider?.logo }}" alt="" style="height: 130px; width: 200px; object-fit: contain;" />

                  </div>
                </div>

                <div class="col-4">
                  <div class="w-100 d-flex flex-column" style="padding: 0px 35px;">
                    <p class="mb-1" style="font-family: 'Poppins'; font-size: 19px; color: #000000; font-weight: 400; line-height: 1.2;">
                      Proveedor
                    </p>
                    <p class="mb-2" style="font-family: 'Poppins'; font-size: 21px; color: #000000; font-weight: 500; line-height: 1.2;">
                      {{ item?.plan?.brand }}
                    </p>
                  </div>
                </div>

                <div class="col-4">
                  <div class="w-100 d-flex flex-column" style="padding: 0px 35px;">
                    <p class="mb-1" style="font-family: 'Poppins'; font-size: 19px; color: #000000; font-weight: 400; line-height: 1.2;">
                      Tipo de Plan
                    </p>
                    <p class="mb-0" style="font-family: 'Poppins'; font-size: 21px; color: #000000; font-weight: 600; line-height: 1.2;">
                      {{ item?.plan?.planName }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-column" style="gap: 1em">
                <!-- Insurance Details -->
                <div *ngIf="!data?.detail" class="row m-0" style="border-bottom: 3px solid #000000;">
                  <!-- Passengers -->
                  <div class="col-4" style="padding: 30px 0px;">
                    <div class="d-flex flex-column" style="gap: 23px; padding: 0px 45px;">
                      <div class="d-flex align-items-center ml-1" style="width: 100%; gap: 10px;">
                        <img src="../../../assets/icons/search-result/persona.svg" width="25px" height="25px" alt="" />
                        <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 600; line-height: 1.2; color: #000000;">
                          {{ item?.plan?.pax?.quantity }} Pax
                        </p>
                      </div>

                      <div class="d-flex align-items-center mr-1" style="width: 100%; gap: 10px;">
                        <img src="../../../../../assets/icons/itinerary/calendar_13937514.svg" class="mb-1" width="30px" height="30px" alt="" />
                        <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 600; line-height: 1.2; color: #000000;">
                          {{ quote ? item?.trip?.days : item.plan?.trip?.days }} Días

                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Dates -->
                  <div class="col-4" style="border-left: 2px solid #bfbfbf; border-right: 2px solid #bfbfbf; padding: 30px 0px;">
                    <div class="d-flex flex-column w-100" style="padding: 0px 45px;">
                      <div class="d-flex flex-column mb-3" style="width: 100%">
                        <p class="mb-1" style="font-family: 'Poppins'; font-size: 15px; font-weight: 600; line-height: 1.2;">
                          Desde
                        </p>
                        <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400; line-height: 1.2;">
                          {{ formatDate(quote ? item?.trip?.startDate : item?.plan?.trip?.startDate) }}
                        </p>
                      </div>
                      <div class="d-flex flex-column" style="width: 100%">
                        <p class="mb-1" style="font-family: 'Poppins'; font-size: 15px; font-weight: 600; line-height: 1.2;">
                          Hasta
                        </p>
                        <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400; line-height: 1.2;">
                          {{ formatDate(quote ? item?.trip?.endDate : item?.plan?.trip?.endDate) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Locations -->
                  <div class="col-4" style="padding: 30px 0px;">
                    <div class="d-flex flex-column w-100" style="padding: 0px 45px;">
                      <div class="d-flex flex-column mb-3" style="width: 100%">
                        <p class="mb-1" style="font-family: 'Poppins'; font-size: 15px; font-weight: 600; line-height: 1.2;">
                          Origen
                        </p>
                        <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400; line-height: 1.2;">
                          {{ quote ? item?.trip?.origin : item?.plan?.form?.begin }}
                        </p>
                      </div>
                      <div class="d-flex flex-column" style="width: 100%">
                        <p class="mb-1" style="font-family: 'Poppins'; font-size: 15px; font-weight: 600; line-height: 1.2;">
                          Destino
                        </p>
                        <p class="mb-0" style="font-family: 'Poppins'; font-size: 14px; font-weight: 400; line-height: 1.2;">
                          {{ quote ? item?.trip?.destination : item?.plan?.form?.destination?.name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              <div style="padding: 30px 0px 60px">
                <div *ngIf="item?.plan?.coverage?.coverageList && item?.plan?.coverage?.coverageList.length > 0" style="padding: 10px 60px 0px; width: 100%;">
                  <p class="mb-4" style="font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 600; line-height: 1.2; padding:
                  0px 15px;">
                    Incluye
                  </p>
                  <ng-container *ngIf="item?.plan?.coverage?.coverageList && item?.plan?.coverage?.coverageList.length > 0">
                    <table style="width: 100%; border-collapse: collapse; font-family: 'Poppins';">
                      <tbody>
                        <tr
                          *ngFor="let coverage of item?.plan?.coverage?.coverageList; let i = index"
                          [ngStyle]="{ 'background-color': i % 2 === 0 ? '#ffffff' : '#f3f3f3' }"
                        >
                          <td style="font-family: 'Poppins'; padding: 18px 18px; font-size: 16px; color: #000000; font-weight: 400; line-height: 1.5; width: '70%';">
                            {{ (coverage?.name || coverage?.type || coverage?.description) | capitalize }}
                          </td>

                          <td style="font-family: 'Poppins'; padding: 15px 18px; font-size: 16px; color: #000000; font-weight: 600; line-height: 1.5; width: 30%; text-align: right;">
                            <ng-container *ngIf="isString(coverage?.coverage); else numericCoverage">
                              {{ coverage?.coverage }}
                            </ng-container>
                            <ng-template #numericCoverage>
                              {{ item?.plan?.pricing?.currency }}
                              {{ coverage?.coverage }}
                            </ng-template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <ng-container *ngIf="!item?.plan?.coverage?.coverageList || item?.plan?.coverage?.coverageList.length === 0">
                    <p class="mb-0" style="font-size: 19px; color: #000000; font-family: 'Poppins'; font-weight: 400; line-height: 1;">
                      N/A
                    </p>
                  </ng-container>
                </div>

                <div *ngIf="item?.addons && item?.addons.length > 0" style="padding: 50px 60px 0px; width: 100%;">
                  <p class="mb-4" style="font-family: 'Poppins', sans-serif; font-size: 18px; font-weight: 600; line-height: 1.2; padding:
                  0px 15px;">
                    Adicionales
                  </p>

                  <ng-container *ngIf="item?.addons && item?.addons.length > 0">
                    <table style="width: 100%; border-collapse: collapse; font-family: 'Poppins';">
                      <tbody>
                        <tr
                          *ngFor="let addon of item?.addons; let i = index"
                          [ngStyle]="{ 'background-color': i % 2 === 0 ? '#ffffff' : '#f2f2f2' }"
                        >
                          <td style="font-family: 'Poppins'; padding: 18px 18px; font-size: 16px; color: #000000; font-weight: 400; line-height: 1.2; width: '70%';">
                            {{ addon?.name || addon?.type || addon?.description || addon }}
                          </td>
                          <td style="font-family: 'Poppins'; padding: 15px 18px; font-size: 16px; color: #000000; font-weight: 600; line-height: 1.2; width: 30%; text-align: right;">
                            <ng-container *ngIf="addon?.coverage !== undefined && addon?.coverage !== null; else noCoverageAddon">
                              {{ item?.plan?.pricing?.currency }}
                              {{ addon?.coverage | number: "1.2-2" }}
                            </ng-container>
                            <ng-template #noCoverageAddon>-</ng-template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </ng-container>
                  <ng-container *ngIf="!item?.addons || item?.addons.length === 0">
                    <p class="mb-0" style="font-size: 19px; color: #000000; font-family: 'Poppins'; font-weight: 400; line-height: 1;">
                      N/A
                    </p>
                  </ng-container>
                </div>
              </div>
              </div>

              <div *ngIf="data?.quote" class="d-flex flex-column align-items-end justify-content-center" style="padding: 60px 60px 0px;
              border-top: 2px solid #bfbfbf;">
                <p class="mb-0" style="font-size: 20px; color: #666666; font-family: 'Rubik'; font-weight: 500; line-height: 1.5;">
                  Total Tarifa Neta
                </p>

                <div class="d-flex">
                  <p class="mb-0" style="font-size: 29px; color: #000000; font-family: 'Rubik'; font-weight: 700; line-height: 1;">
                    <!-- {{ item?.plan?.pricing?.currency }}
                    {{ item?.plan?.profility?.netPriceBooking    | currencyConverterPure: result["insurances"][0]["plan"]["pricing"]["currency"] : currencyAgency?.code : currencies
                | number: "1.2-2"}} -->
                      {{ currencyAgency?.code }} {{ item?.plan?.profility?.netPriceBooking    | currencyConverterPure: item?.plan?.pricing?.currency : currencyAgency?.code : currencies
                | number: "1.2-2"}}
                  </p>
                  <usb-tooltip-convert-amount
                    [clientsSettingAppBooking]="clientSetting"
                    [currencyProduct]="item?.plan?.pricing?.currency"
                    [valueProduct]="item?.plan?.profility?.netPriceBooking"
                  >
                  </usb-tooltip-convert-amount>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div
  *ngIf="loadInsurance && data?.quote"
  class="row d-flex align-items-center justify-content-between w-100"
  style="margin-left: 0em; border-top: 2px solid #bfbfbf; padding: 50px 50px;"
>
  <div *ngIf="insurances && insurances.length > 0" class="d-flex align-items-center">
    <p style="margin: 0; font-family: 'Poppins'; font-weight: 600; font-size: 25px; line-height: 1.2; color: #000000;">{{ insurances[0]?.plan?.planName }}</p>
  </div>

  <div class="d-flex align-items-center justify-content-end" style="height: 75px; gap: 1em">
    <div class="d-flex flex-column align-items-end justify-content-center">
      <p class="mb-0" style="font-size: 20px; color: #666666; font-family: 'Rubik'; font-weight: 500; line-height: 1.5;">
        Total Tarifa Neta
      </p>

      <div class="d-flex">
        <p class="mb-0" style="font-size: 29px; color: #000000; font-family: 'Rubik'; font-weight: 700; line-height: 1;">
          <!-- {{ insurances[0]?.plan?.pricing?.currency }} {{ getTotalPriceInsurance() | number: "1.2-2" }} -->
          {{ currencyAgency?.code }} {{ getTotalPriceInsurance() | number: "1.2-2" }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="pull-right btn btn-continue cursor-pointer h-100"
      [ngStyle]="{ 'background-color': clientSetting?.clients_setting_global?.color_main_1 }"
      (click)="confirm()"
    >
      Continuar
    </button>
  </div>
</div>
